import { Button } from "@hatch-digital-nl/abs-storybook/legacy";
import { JSX } from "react";

interface Props {
    label: string;
    isLoading: boolean;
    onClick?: () => void;
    disabled?: boolean;
}

export const SubmitButtonComponent = (props: Props): JSX.Element => {
    const { isLoading, onClick, label, disabled } = props;

    return (
        <div className={"c-form__form-group c-form__form-group--button"}>
            <Button
                type={"submit"}
                variant={"primary"}
                disabled={isLoading || disabled}
                loading={isLoading}
                onClick={onClick && (() => onClick())}
            >
                {label}
            </Button>
        </div>
    );
};
